import {
	DashboardOutlined,
	BarChartOutlined,
	SettingOutlined,
	RadarChartOutlined,
	CloudUploadOutlined,
	FileExcelOutlined,
} from "@ant-design/icons";
import { PATH } from "../../router/path.constant";

const Items = [
	{
		key: "home",
		icon: <DashboardOutlined />,
		link: PATH.home.path,
		name: "图表",
		allowedRole: PATH.home.allowedRole,
		isShow: true,
	},
	{
		key: "record",
		icon: <BarChartOutlined />,
		link: PATH.record.path,
		name: "Records",
		allowedRole: PATH.record.allowedRole,
		isShow: false,
	},
	{
		key: "allocations",
		icon: <BarChartOutlined />,
		link: PATH.allocation.path,
		name: "分车管理",
		allowedRole: PATH.allocation.allowedRole,

		isShow: true,
	},
	{
		key: "文件",
		icon: <CloudUploadOutlined />,
		link: PATH.upload.path,
		name: "文件上传",
		allowedRole: PATH.upload.allowedRole,

		isShow: true,
	},
	{
		key: "result",
		icon: <RadarChartOutlined />,
		link: PATH.result.path,
		name: "汇总",
		allowedRole: PATH.result.allowedRole,

		isShow: true,
	},
	{
		key: "export",
		icon: <FileExcelOutlined />,
		link: PATH.export.path,
		name: "导出",
		allowedRole: PATH.export.allowedRole,

		isShow: true,
	},
	{
		key: "settings",
		icon: <SettingOutlined />,
		link: PATH.settings.path,
		name: "设置",
		allowedRole: PATH.settings.allowedRole,

		isShow: true,
	},
];

export const MenuItems = Items.filter((item) => item.isShow);
